module.exports = __webpack_public_path__ + "img/baner-das-weltauto.d4b329ef.png";